const vwoOnVariationApplied = [
    {
        selector: 'body',
        path: { filename: 'vwoOnVariationApplied' },
    },
];

export { vwoOnVariationApplied };
